var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterviewers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8751 11C28.8751 12.8234 28.1508 14.572 26.8615 15.8614C25.5722 17.1507 23.8235 17.875 22.0001 17.875C20.1768 17.875 18.4281 17.1507 17.1388 15.8614C15.8494 14.572 15.1251 12.8234 15.1251 11C15.1251 9.17664 15.8494 7.42795 17.1388 6.13864C18.4281 4.84933 20.1768 4.125 22.0001 4.125C23.8235 4.125 25.5722 4.84933 26.8615 6.13864C28.1508 7.42795 28.8751 9.17664 28.8751 11ZM8.25195 36.883C8.31087 33.2756 9.78524 29.836 12.3571 27.3057C14.929 24.7755 18.3923 23.3575 22.0001 23.3575C25.608 23.3575 29.0713 24.7755 31.6431 27.3057C34.215 29.836 35.6894 33.2756 35.7483 36.883C31.4352 38.8607 26.7451 39.8814 22.0001 39.875C17.0941 39.875 12.4375 38.8043 8.25195 36.883Z",
    stroke: "#FEDA14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewers);
export default __webpack_public_path__ + "static/media/interviewers.2f9415500300fb802dd6b3e0c43c7782.svg";
export { ForwardRef as ReactComponent };